import {
    Outlet
} from 'react-router-dom';


function WordTypeContainer() {

    return(
        <div className="p-10 text-black bg-white">
            <Outlet />
        </div>
    );
}

export default WordTypeContainer;